let Vue = require('vue');
let Promise = require('bluebird');
let search = require('sci/ui/search');

/**
 * TODO: Component with this
 */
Vue.directive('pipeline-search', {
    priority: 1000,

    bind: function () {
        search($(this.el).addClass('pipeline-search').parent());
    },
    update: function (value) {

    },
    unbind: function () {
        //$(this.el).off().select2('destroy')
    }
});




// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/pipeline-search.js